/* eslint no-param-reassign: 0 */

const mutations = {
  SET_SFW_MODE(state, paranoiaLevel) {
    state.sfwMode = paranoiaLevel;
  },

  SET_BOB_INDEXES(state, val) {
    state.bobIndexes = val;
  },
};

export default mutations;
